export default "__VITE_ASSET__CSJHoA8l__"